import { Box, Tooltip } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import { Theme, WithStyles, withStyles } from "@material-ui/core/styles";
import { Info } from "@material-ui/icons";
import * as React from "react";
import { withSchoolContext } from "src/pages/DirectorPage";
import { AppContextConsumer, IAppContext } from "./withAppContext";
import { ISchool } from "src/services";
const styles = (theme: Theme) => ({
  content: {
    backgroundColor: theme.palette.common.white,
    borderRadius: 3,
    padding: "1rem",
  },
  gritLogo: {
    height: "4.5em",
  },
  headerLink: {
    "&:hover": {
      color: "#898989",
    },
    color: "#474747",
    transition: "all 0.1s ease-in-out",
  },
  headerWrapper: {
    [theme.breakpoints.down("xs")]: {
      width: "min-content",
    },
  },
  infoIcon: {
    marginLeft: "1rem",
  },
  pageHeader: {
    alignItems: "center",
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    display: "flex",
    justifyContent: "space-between",
    padding: "1rem",
  },
  schoolLogo: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: "50%",
    height: "40px",
    overflow: "hidden",
    padding: "0.1rem",
    width: "40px",
  },
  helpIconContainer: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: "50%",
    height: "40px",
    width: "40px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "0.1rem",
    overflow: "hidden",
  },
  schoolLogoImage: {
    // backgroundColor: theme.palette.background.paper,
    borderRadius: "50%",
    height: "100%",
    overflow: "hidden",
    width: "100%",

  },
  circleContainer: {
    display: 'flex',
    justifyContent: 'center', // Horizontally center
    alignItems: 'center',     // Vertically center
    overflow: 'hidden',
    width: '100%',      // Set the width and height of the circle
    height: '100%',
    borderRadius: '50%', // Make it a circle  
  },
  schoolLogoImageSubscription: {
    width: '80%',      // Set the image to cover the entire area
    height: '80%',

  },
  text: {
    color: "#d5d5d5",
    fontSize: "1.1em",
    textDecoration: "none",
  },
});

interface IDirectorPageProps {
  children: React.ReactNode;
  header: string;
  title?: string;
  subtitle?: string;
  className?: any;
  school?: ISchool;
}

interface IDirectorPagePropsWithAxiosAndStyles
  extends IDirectorPageProps,
  IAppContext,
  WithStyles<keyof ReturnType<typeof styles>> { }

const DirectorPage: React.FC<IDirectorPagePropsWithAxiosAndStyles> =
  withSchoolContext(
    ({
      classes,
      children,
      header,
      title,
      subtitle,
      className,
      school,
    }: IDirectorPagePropsWithAxiosAndStyles) => {

      return (
        <>
          <Box
            className={classes.pageHeader}
            style={{ backgroundColor: school?.primaryColor }}
          >
            <Box
              display="flex"
              flexDirection="row"
              alignItems={title ? "flex-start" : "center"}
            >
              <Box className={classes.headerWrapper}>
                <Typography variant="h4" style={{ color: school?.secondaryColor }}>{header}</Typography>
                {!!title && (
                  <Typography variant="subtitle2" style={{ color: school?.secondaryColor }}>{title}</Typography>
                )}
              </Box>
              {subtitle && (
                <Box marginTop={!!title ? "0.5rem" : "0px"}>
              <Tooltip
  enterTouchDelay={0}
  leaveTouchDelay={5000}
  className={classes.infoIcon}
  placement="bottom"
  title={
    <Typography style={{ fontSize: "14px" }}> 
      {subtitle} 
    </Typography>
  }
>
<Info style={{ 
  color: school?.secondaryColor, 
  fontSize: "25px" 
}} />
</Tooltip>

                </Box>
              )}
            </Box>
            <div style={{ flexDirection: 'row', display: 'flex' }}>
              {/* <div style={{ marginRight: 20, marginLeft: 20 }}>

                {!!school?.slug && <Box className={classes.schoolLogo}>
                  <Link to={`/${school?.slug}/subscription-history`}>
                    <Tooltip title={"User subscription purchase history"} enterTouchDelay={0} className="manageSubscription">
                      <Box className={classes.circleContainer}>
                        <img alt="subscription details" src={SubScriptionLogo} className={classes.schoolLogoImageSubscription} />
                      </Box>
                    </Tooltip>
                  </Link>
                </Box>}
              </div> */}
              <div style={{ marginRight: 20 }}>
                {!!school?.logo1 && (
                  <Box className={classes.schoolLogo}>
                    <Tooltip title={school.name} enterTouchDelay={0}>
                      <img alt="school logo" width="100%" src={school.logo1} className={classes.schoolLogoImage} />
                    </Tooltip>
                  </Box>
                )}
              </div>
            </div>


          </Box>
          <Box className={`${classes.content} ${className}`}>{children}</Box>
        </>
      );
    }
  );

const StyledDirectorPage = withStyles(styles)(DirectorPage);

export default (props: IDirectorPageProps) => (
  <AppContextConsumer>
    {(context) => <StyledDirectorPage {...context} {...props} />}
  </AppContextConsumer>
);



// WEBPACK FOOTER //
// ./src/components/Page.tsx